import { render, staticRenderFns } from "./ProjectListCreate.vue?vue&type=template&id=25fa6b51"
import script from "./ProjectListCreate.vue?vue&type=script&lang=js"
export * from "./ProjectListCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports